import { Routes } from '@angular/router';
import { canDeactivateFormFn } from '@core/guards';
import { ConnectionsWrapperComponent } from './components/connections-wrapper/connections-wrapper.component';
import { apiConnectionResolverFn } from './resolvers/api-connection.resolver';
import { bpmnConnectionResolverFn } from './resolvers/bpmn-connection.resolver';
import { databaseConnectionResolverFn } from './resolvers/database-conection.resolver';
import { smtpConnectionResolverFn } from './resolvers/smtp-connection.resolver';
import { storageConnectionResolverFn } from './resolvers/storage.resolver';

export const routes: Routes = [
	{
		path: '',
		data: {
			breadcrumb: 'CONNECTIONS.BREADCRUMBS.MAIN'
		},
		children: [
			{
				path: '',
				component: ConnectionsWrapperComponent,
				children: [
					{
						path: '',
						redirectTo: 'databases',
						pathMatch: 'full'
					},
					{
						path: 'databases',
						data: {
							breadcrumb: 'DATABASE_CONNECTION_LIST.BREADCRUMBS.MAIN'
						},
						loadComponent: () =>
							import(
								'./components/database-connections/database-connection-list/database-connection-list.component'
							).then((component) => component.DatabaseConnectionListComponent)
					},
					{
						path: 'apis',
						data: { breadcrumb: 'API_CONNECTION_LIST.BREADCRUMBS.MAIN' },
						loadComponent: () =>
							import(
								'./components/api-connections/api-connection-list/api-connection-list.component'
							).then((component) => component.ApiConnectionListComponent)
					},
					{
						path: 'storages',
						data: {
							breadcrumb: 'STORAGE_CONNECTION_LIST.BREADCRUMBS.MAIN'
						},
						loadComponent: () =>
							import(
								'./components/storage-connections/storage-connection-list/storage-connection-list.component'
							).then((component) => component.StorageConnectionListComponent)
					},
					{
						path: 'smtps',
						data: { breadcrumb: 'SMTP_CONNECTION_LIST.BREADCRUMBS.MAIN' },
						loadComponent: () =>
							import(
								'./components/smtp-connections/smtp-connection-list/smtp-connection-list.component'
							).then((component) => component.SmtpConnectionListComponent)
					},
					{
						path: 'bpmns',
						data: { breadcrumb: 'BPMN_CONNECTION_LIST.BREADCRUMBS.MAIN' },
						loadComponent: () =>
							import(
								'./components/bpmn-connections/bpmn-connection-list/bpmn-connection-list.component'
							).then((component) => component.BpmnConnectionListComponent)
					}
				]
			},
			{
				path: 'databases/:connectionId',
				canDeactivate: [
					(component, currentRoute, currentState, nextState) =>
						canDeactivateFormFn(component.form, {
							componentRef: component,
							nextState
						})
				],
				resolve: { connection: databaseConnectionResolverFn },
				data: {
					breadcrumb: 'DATABASE_CONNECTION_EDITION.BREADCRUMBS.MAIN'
				},
				loadComponent: () =>
					import(
						'./components/database-connections/database-connection-edition/database-connection-edition.component'
					).then((component) => component.DatabaseConnectionEditionComponent)
			},
			{
				path: 'apis/:connectionId',
				canDeactivate: [
					(component, currentRoute, currentState, nextState) =>
						canDeactivateFormFn(component.form, {
							componentRef: component,
							nextState
						})
				],
				resolve: { connection: apiConnectionResolverFn },
				data: { breadcrumb: 'API_CONNECTIONS_EDITION.BREADCRUMBS.MAIN' },
				loadComponent: () =>
					import(
						'./components/api-connections/api-connection-edition/api-connection-edition.component'
					).then((component) => component.ApiConnectionEditionComponent)
			},
			{
				path: 'storages/:connectionId',
				canDeactivate: [
					(component, currentRoute, currentState, nextState) =>
						canDeactivateFormFn(component.form, {
							componentRef: component,
							nextState
						})
				],
				resolve: { connection: storageConnectionResolverFn },
				data: {
					breadcrumb: 'STORAGE_CONNECTION_EDITION.BREADCRUMBS.MAIN'
				},
				loadComponent: () =>
					import(
						'./components/storage-connections/storage-connection-edition/storage-connection-edition.component'
					).then((component) => component.StorageConnectionEditionComponent)
			},
			{
				path: 'smtps/:connectionId',
				canDeactivate: [
					(component, currentRoute, currentState, nextState) =>
						canDeactivateFormFn(component.form, {
							componentRef: component,
							nextState
						})
				],
				resolve: { connection: smtpConnectionResolverFn },
				data: {
					breadcrumb: 'SMTP_CONNECTION_EDITION.BREADCRUMBS.MAIN'
				},
				loadComponent: () =>
					import(
						'./components/smtp-connections/smtp-connection-edition/smtp-connection-edition.component'
					).then((component) => component.SmtpConnectionEditionComponent)
			},
			{
				path: 'bpmns/:connectionId',
				canDeactivate: [
					(component, currentRoute, currentState, nextState) =>
						canDeactivateFormFn(component.form, {
							componentRef: component,
							nextState
						})
				],
				resolve: { connection: bpmnConnectionResolverFn },
				data: {
					breadcrumb: 'BPMN_CONNECTION_EDITION.BREADCRUMBS.MAIN'
				},
				loadComponent: () =>
					import(
						'./components/bpmn-connections/bpmn-connection-edition/bpmn-connection-edition.component'
					).then((component) => component.BpmnConnectionEditionComponent)
			}
		]
	}
];
